import jQuery from 'jquery';

export default function newsApi() {

    jQuery(() => {
        function generateNews(data, responseContainer) {
            const markup = data.map((news) => {
                let tagsString = '';

                if (news.tags) {
                    news.tags.forEach((tag) => {
                        if (tag.id === '3') {
                            tagsString += ' photo';
                        }
                        if (tag.id === '2') {
                            tagsString += ' video';
                        }
                    });
                }

                return `
                    <article class="news-box col-sm-4 ${tagsString}">
                        <a href="${news.path}">
                            <div class="news-box__img">

                                ${news.list_img_url ? `<img src="${news.list_img_url}" alt="${news.list_img_alt}" />` :
                                '<img src="data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==" alt="">'}

                                <div class="news-box__read-more">
                                    Czytaj więcej
                                </div>
                            </div>
                            <div class="news-box__caption">
                                <h3>${news.name}</h3>
                            </div>
                            <div class="news-box__date">
                                <time datetime="${news.date}">${news.date}</time>
                            </div>
                        </a>
                    </article>
                `;
            });

            responseContainer.html(markup.length ? markup : '<span>Nie znaleziono żadnych wyników</span>');
            responseContainer.removeClass('loading');
        }

        function getNewsFromCategory(url, element) {
            const tag = element.data('tag');
            const parameters = (tag) ? { tags: [tag], limit: 15 } : { limit: 15 };

            const responseContainer = jQuery(element).closest('.latest-news').find('.news-boxes');

            jQuery(element).siblings('.btn--secondary').removeClass('btn--secondary').addClass('btn--primary');
            jQuery(element).addClass('btn--secondary').removeClass('btn--primary');

            jQuery(responseContainer).addClass('loading');

            jQuery.get(url, parameters)
                .done((response) => {
                    generateNews(response.news, responseContainer);
                });
        }

        // submit on tag button click
        const mainSelector = jQuery('#new-from-category__blog-tags');
        mainSelector.on('click', 'a', function (e) {
            e.preventDefault();
            getNewsFromCategory(mainSelector.data('action'), jQuery(this));
        });
    });
}
